/**
 * Authenticated proforma download/print helpers (dashboard).
 */
import { storage } from "./storage";

async function authHeaders() {
  const token = await storage.load("token");
  if (!token) throw new Error("login_required");
  return { "x-auth": token };
}

export async function printProformaHtml(url) {
  const headers = await authHeaders();
  const res = await fetch(url, { headers });
  if (res.status === 401) throw new Error("login_required");
  if (res.status === 403) throw new Error("forbidden");
  if (res.status === 409) throw new Error("not_finalized");
  if (!res.ok) throw new Error("proforma_failed");
  const html = await res.text();
  const w = window.open("", "_blank");
  if (!w) throw new Error("popup_blocked");
  w.document.open();
  w.document.write(html);
  w.document.close();
  setTimeout(() => {
    try {
      w.focus();
      w.print();
    } catch (_) {}
  }, 400);
}

export async function downloadProformaPdf(url, filename) {
  const headers = await authHeaders();
  const res = await fetch(url, { headers });
  if (res.status === 401) throw new Error("login_required");
  if (res.status === 403) throw new Error("forbidden");
  if (res.status === 409) throw new Error("not_finalized");
  if (!res.ok) throw new Error("proforma_failed");
  const blob = await res.blob();
  const a = document.createElement("a");
  const obj = URL.createObjectURL(blob);
  a.href = obj;
  a.download = filename || "proforma.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(obj);
}
